import { css } from 'emotion';

import { colors, icons } from '../styles';

export const svgIcon = (hovered: boolean) => css`
  color: ${hovered ? colors.gray.dark : colors.gray.default};

  && {
    font-size: ${icons.size.small};
  }
`;

export const iconWrapper = css`
  display: flex;
`;
